import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

export default function SmoothScroll({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);

    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

    return children;
}
